import Vue from 'vue';
import store from '@/store.js';
import snackbar from './snackbar';
import i18n from '@/i18n';

function permissionAllow(c, a) {
    if (store.state.allow) {
        let controller = store.state.allow[c];
        if (controller) {
            if (!controller.find((action) => a == action))
                return false;
        } else return false;

        return true;
    }
    return false;
}

function accountExpired() {
    return new Date() > new Date(Date.parse(store.state.accountInfo.time_expired));
}
Vue.filter('accountExpired', accountExpired);

async function checkAccountExpired() {
    return new Promise((resolve) => {
        if (!accountExpired()) {
            resolve();
        } else {
            snackbar.error(i18n.t("App.accountExpired"));
        }
    });
}

export default {
    permissionAllow,
    accountExpired,
    checkAccountExpired
}